import { formatNumbersForDisplay } from 'utils/helpers'
import { ITankLevelBarProps } from 'types/fuelOps.interface'
import { TankMetricLabel } from './FuelTanks.styled'
import {
    DualTrack,
    DualTrackHalf,
    LevelBarRow,
    LevelBlock,
    LevelFill,
    LevelLitres,
    LevelPct,
    LevelText,
    LevelTick,
    LevelTrack,
    SensorDeltaNote,
    TrackColumn,
    TrackLegend,
} from './TankLevelBar.styled'

const LEVEL_TICKS = [25, 50, 75]

const SENSOR_DELTA_TOLERANCE_PCT = 2

export const TankLevelBar = ({ pct, tone, currentAmount, capacity, sensorPct, sensorAmount }: ITankLevelBarProps) => {
    const hasSensor = sensorPct != null
    const deltaLitres = hasSensor && sensorAmount != null ? Math.abs(currentAmount - sensorAmount) : 0
    const deltaPct = capacity > 0 ? (deltaLitres / capacity) * 100 : 0
    const showDelta = deltaPct > SENSOR_DELTA_TOLERANCE_PCT
    const ticks = LEVEL_TICKS.map((tick) => <LevelTick key={tick} $at={tick} />)
    return (
        <LevelBlock>
            <TankMetricLabel>Level</TankMetricLabel>
            <LevelBarRow>
                {hasSensor ? (
                    <TrackColumn>
                        <DualTrack>
                            {ticks}
                            <DualTrackHalf>
                                <LevelFill $pct={pct} $tone={tone} />
                            </DualTrackHalf>
                            <DualTrackHalf>
                                <LevelFill $pct={sensorPct} $tone='info' />
                            </DualTrackHalf>
                        </DualTrack>
                        <TrackLegend>DIP · SENSOR</TrackLegend>
                    </TrackColumn>
                ) : (
                    <LevelTrack>
                        {ticks}
                        <LevelFill $pct={pct} $tone={tone} />
                    </LevelTrack>
                )}
                <LevelText>
                    <LevelPct>{`${pct}%`}</LevelPct>
                    <LevelLitres>{`${formatNumbersForDisplay(currentAmount)} / ${formatNumbersForDisplay(capacity)} L`}</LevelLitres>
                    {showDelta && (
                        <SensorDeltaNote>
                            {`Sensor differs by ${formatNumbersForDisplay(deltaLitres)} L — check calibration`}
                        </SensorDeltaNote>
                    )}
                </LevelText>
            </LevelBarRow>
        </LevelBlock>
    )
}
